var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLemlistIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#316BFF",
  fillRule: "evenodd",
  d: "M3.614-.001h12.524a3.46 3.46 0 0 1 3.463 3.463v12.524a3.46 3.46 0 0 1-3.463 3.463H3.614a3.46 3.46 0 0 1-3.462-3.463V3.463A3.46 3.46 0 0 1 3.614 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.481 5.228h4.397a.51.51 0 0 1 .51.51v.792a.51.51 0 0 1-.51.51H9.481a.51.51 0 0 1-.51-.51v-.792a.51.51 0 0 1 .51-.51m.004 3.61h3.491a.51.51 0 0 1 .51.51v.79a.51.51 0 0 1-.51.51H9.485a.51.51 0 0 1-.51-.51V9.35a.51.51 0 0 1 .51-.51"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.392 12.957v.789a.51.51 0 0 1-.51.51H7.361a2.145 2.145 0 0 1-2-2V5.703a.51.51 0 0 1 .51-.51h.782a.51.51 0 0 1 .51.51v5.435c0 .734.528 1.309 1.262 1.309h5.455a.51.51 0 0 1 .51.51"
})));
export { SvgLemlistIcon as ReactComponent };
export default __webpack_public_path__ + "d24e6dbab318c68c7d5a6b32f8a578f3.svg";